import { IUseGraphqlQueryOptions } from '@proscom/prostore-apollo-react';
import { useAuthGraphqlQuery } from '../../../common/hooks/utils/useAuthGraphqlQuery';
import { ONE_PAGE_ITEMS } from '../../../constants';
import { QUERY_GET_OFFERS_PAGE } from '../../queries/offers';
import {
  OffersFilter,
  OffersPageInput,
  OffersPageType,
  PaginationInput
} from '../../types';

export interface UseOffersPageVars {
  input: OffersPageInput;
}

export interface UseOffersPageArgs {
  filter?: OffersFilter;
  pagination?: PaginationInput;
}

const queryOptions: IUseGraphqlQueryOptions<
  UseOffersPageVars,
  OffersPageType
> = {
  query: QUERY_GET_OFFERS_PAGE,
  mapData: (result) => result.offersPage
};

export function useOffersPage({ filter, pagination }: UseOffersPageArgs) {
  return useAuthGraphqlQuery({
    queryOptions,
    variables: {
      input: {
        filter,
        pagination: {
          onePage: ONE_PAGE_ITEMS,
          ...pagination
        }
      }
    }
  });
}
